import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'

import useDayAndHourData from '../useDayAndHourData'

const DemographicEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const dayAndHourData = useDayAndHourData(widgetId)
  const { t } = useTranslation()

  if (dayAndHourData.isEmpty) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  return children
}

export default DemographicEmptyResultGuard
